module.exports = __webpack_public_path__ + "static/MOD5-acf25061c86e49692d87625d5e99acf0.jpg";